import React from "react";
import { Outlet } from "react-router-dom";
import styles from "./styles.module.css";

export function AuthOutlet() {
  return (
    <div className={styles.auth}>
      <Outlet />
    </div>
  );
}
